import React from "react"
import {
	WithI18nProps,
	withI18n,
} from "@7egend/web-core/lib/components/withI18n"
import {
	BlockComponentProps,
	BlocksEditor,
	Wrapper,
} from "@7egend/dxp-web-core/lib/components"
import { Block, Container, Text } from "@7egend/web-core-cms/lib/dlos"
import { CUSTOM_BLOCKS } from "@/configs/blocks"
import { blockTypes } from "@7egend/dxp-web-core/lib/components/BlockDrawer/BlockType/config"
import { FaqsContainer } from "@/dlos/reservations"

const Structure = {
	id: undefined,
	type: blockTypes.container.type,
	content: {
		id: undefined,
		name: "Container",
		style: "1002",
		blocks: [],
	},
} as unknown as Partial<
	Pick<Block<Pick<FaqsContainer, "blocks">>, "type" | "content">
>

const ComponentInner: React.FC<
	BlockComponentProps<FaqsContainer> & WithI18nProps
> = ({ data, updateData, t, locale }) => {
	return (
		<Wrapper>
			<BlocksEditor
				sortable={false}
				allowAdd={false}
				allowRemove={false}
				types={[CUSTOM_BLOCKS.overrides.title, CUSTOM_BLOCKS.overrides.text]}
				blocks={data.content?.blocks || []}
				onChange={(blocks: Block[]) =>
					updateData({
						...data,
						content: {
							...data.content,
							blocks: [
								(blocks as Block<Text>[])[0],
								(blocks as Block<Text>[])[1],
							],
						},
					})
				}
				locale={locale}
			/>
		</Wrapper>
	)
}

const Component = withI18n()(ComponentInner)

const Button = {
	icon: "widgets",
	name: "Reservation FAQ",
}

export const ReservationFaq = {
	key: "5_1002",
	Structure: Structure as any as Block<Container<Text>>,
	Component,
	Button,
}
